import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 5c2.941 0 6.685 1.537 9 3l-2 11h-14l-2 -11c2.394 -1.513 6.168 -3.005 9 -3","key":"svg-0"}],["path",{"d":"M10 12h4","key":"svg-1"}],["path",{"d":"M12 10v4","key":"svg-2"}]]

const IconNurse = createReactComponent('outline', 'nurse', 'Nurse', __iconNode);

export default IconNurse;